import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { offboarding } from "../../modules/offboarding";


declare var ko: any;

export class usersProfileInternalNote_template extends vnTemplate {


    protected getTemplateHtml(): string {

        return ` <article data-bind="visible: visible" class="user-dashboard w-form internal-notes" style="width: calc(100% - 4rem);">

                  <div class="form-group" id="application-history-section">
                                    <div class="form-group"></div>
                                    <h3 class="form-sub-title no-margin icon i-samples app-history">Application History</h3>
                                    </div>
                                    <div class="form-group">
                                        <div class="w-list-results">
                                            <!-- ko if: applicationHistory().length > 0 -->
                                            <table class="list-results">
                                                <thead>
                                                    <tr>
                                                        <th><span>Position</span></th>
                                                        <th class="time-width"><span>Application <br> Status</span></th>
                                                        <th class="time-width"><span>Steps <br> Completed</span></th>
                                                        <th class="time-width"><span>HR Status</span></th>
                                                        <th><span>Rejection <br> Reason</span></th>
                                                        <th class="time-width"><span>Date Created</span></th>
                                                        <th class="time-width"><span>Date Updated</span></th>                                                    
                                                    </tr>
                                                </thead>
                                                <tbody data-bind="foreach: applicationHistory">
                                                    <tr class="cursor" data-bind="click: function() { window.open(jobApplicationLink, '_blank') }, attr: { 'data-application-id': applicationId }">
                                                        <td>
                                                            <div class="flex">
                                                                <span data-bind="css: brandIconImage" class="dark full-icon"></span><span data-bind="text: positionName"></span>
                                                            </div>
                                                        </td>
                                                        <td class="time-width"><span data-bind="text: applicationStatus"></span></td>
                                                        <td class="time-width"><span data-bind="text: stepsCompleted"></span> / <span data-bind="text: totalSteps"></span></td>
                                                        <td class="time-width"><span data-bind="text: hrStatus"></span></td>
                                                        <td class="rejection-reason">
                                                            <!-- ko if: idRejectionReason > 0 -->
                                                            <h2 class="rejection-title" data-bind="css: { red: rejectionColor == 'red',  yellow: rejectionColor == 'yellow' },text: reasonForRejection"></h2>               
                                                            <p class="rejection-info">  By  
                                                            <span class="rejection-info" data-bind="text: rejectedBy"></span>               
                                                            </p>
                                                            <p class="rejection-info" data-bind="text: rejectionTime"></p>               
                                                            <!-- /ko -->
                                                        </td>
                                                        <td class="time-width"><span data-bind="text: dateCreated"></span></td>
                                                        <td class="time-width"><span data-bind="text: dateUpdated"></span></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <!-- /ko -->
                                            <!-- ko if: applicationHistory().length == 0 -->
                                            <div class="form group no-result">
                                                <span class="icon i-samples"></span>
                                                <h2>No Application History Found</h2>
                                            </div>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                    <div class="form-group form-comment" id="brand-access-notes-section">
                                       <h3 class="form-sub-title no-margin icon i-brand brand-history">Brand Access Notes</h3>
                                    </div>                                    
                                    <div class="form-group">
                                        <!-- ko if: offboardingHistory().length > 0 -->

                                        <div class="w-list-results">
                                            <table class="list-results">
                                                <thead>
                                                    <tr>
                                                        <th><span>Brand Status</span></th>
                                                        <th><span>Offboarding Reason</span></th>
                                                        <th><span>Article Count</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody data-bind="foreach: offboardingHistory">
                                                    <tr>
                                                        <td>
                                                            <div class="flex">
                                                               <span data-bind="css: brandIconImage" class="dark full-icon"></span><span data-bind="text: brandStatus"></span>
                                                            </div>
                                                        </td>
                                                        <td class="rejection-reason">
                                                            <!-- ko if: idRejectionReason > 0 -->

                                                            <h2 class="rejection-title" data-bind="css: { 'hide': idRejectionReason === 0, 'red': idRejectionReason > 0 && idRejectionReason <= 6, 'yellow': idRejectionReason > 6 }, text: idRejectionReason === 0 ? '' :  offboardingReason"></h2>
                                                            <p class="rejection-info">
                                                                <span class="rejection-info" data-bind="text: 'By ' + offboardingResponsible"></span>  
                                                            </p>
                                                            <p class="rejection-info">
                                                                <span  class="rejection-info" data-bind="text: offboardingTimestamp"></span>             
                                                            </p>
                                                            <!-- /ko -->
                                                        </td>
                                                        <td>
                                                            <div class="flex">
                                                                <span style="flex: none; width: 6rem" data-bind="text: articleCount"></span>
                                                                <a class="btn icon border only-icon i-link" data-bind="attr:{href: articlesLink}" target="_blank"> </a>
                                                            </div>    
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- /ko -->
                                        <!-- ko if: offboardingHistory().length == 0 -->
                                        <div class="form-group no-result">
                                            <span class="icon i-brand"></span>
                                            <h2 class="form-title no-margin">No Brand Access Notes Found</h2>
                                        </div>
                                        <!-- /ko -->                                        
                                    </div>   
                </article>
            `;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string {

        return "usersProfileInternalNote-template";
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return [""];
    }

    protected buildViewModel(): any {

        let self = this;

        return {
            visible: ko.observable(false),
            hasData: ko.observable(true),
            applicationHistory : ko.observable([]),
            offboardingHistory : ko.observable([]),          
        }
    }


        
    public setOffboardingHistory(offboardingHistory) {
        for(let offboarding of offboardingHistory){

            offboarding.articlesLink = window.location.origin +'/brand/'+offboarding.idBrand+'/articles/?authors=%5B%7B"id"%3A'+offboarding.idAuthor+'%2C"name"%3A"'+offboarding.userName+'"%7D%5D' ;
        }
        this.getTemplateViewModel().offboardingHistory(offboardingHistory);
    }

    public setApplicationHistory(applicationHistory) {
        this.getTemplateViewModel().applicationHistory(applicationHistory);
    }

    public setVisible(visible) {

        this.getTemplateViewModel().visible(visible);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/usersProfileInternalNote_template.ts